import { Injectable } from '@angular/core';
import { NEVER } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { PartnerDataService } from 'src/app/services';
import { handleError } from 'src/app/state/akita-error-helper';
import { CollectionState } from 'src/app/state/collection-state';
import { Partner } from 'src/app/models/domain';

@Injectable({ providedIn: 'root' })
export class PartnerService {
  private readonly state = new CollectionState<Partner>();

  public readonly partners$ = this.state.items$;
  public readonly loading$ = this.state.loading$;
  public readonly error$ = this.state.error$;

  public constructor(private readonly partnerDataService: PartnerDataService) {}

  public loadByObjectNumber(objectNumber: string) {
    this.state.setLoading(true);

    return this.partnerDataService.getPartnersByObjectNumber(objectNumber).pipe(
      tap((entities) => {
        this.state.set(entities);
      }),
      catchError((error) => {
        handleError(this.state, error);

        return NEVER;
      }),
      map(() => undefined)
    );
  }

  public reset() {
    this.state.reset();
  }
}
